import {
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ContactHandlesList } from '@/components/ui/ContactHandlesList';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

import { CoverageFormData } from '../types';

interface SubrogatorSectionProps {
  register: UseFormRegister<CoverageFormData>;
  setValue: UseFormSetValue<CoverageFormData>;
  watch: UseFormWatch<CoverageFormData>;
}

export const SubrogatorSection = ({
  register,
  setValue,
  watch,
}: SubrogatorSectionProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Subrogator</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="subrogator.name">Subrogator Name</Label>
          <Input
            id="subrogator.name"
            placeholder="e.g., Jane Doe"
            {...register('subrogator.name')}
          />
        </div>

        <div className="space-y-2">
          <Label>Subrogator Contact Information</Label>
          <ContactHandlesList
            handles={watch('subrogator.handles') || []}
            onUpdate={async (handles) =>
              setValue(
                'subrogator.handles',
                handles.length > 0 ? handles : null,
              )
            }
            title=""
            emptyStateTitle="No subrogator contacts"
            emptyStateDescription="Add contact information for the subrogator."
          />
        </div>

        <div className="space-y-2">
          <Label>Sources</Label>
          <div className="text-sm text-gray-500">
            Subrogator sources are managed automatically during coverage
            processing.
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
